import { ShieldCheck, Handshake, MapPin } from "lucide-react";
import { TRUST_ITEMS } from "@/constants/site";
import { Reveal } from "@/lib/motion";

const ICONS = { ShieldCheck, Handshake, MapPin };

export const TrustStrip = ({ content = {} }) => (
  <section id="guven" data-testid="trust-strip" className="bg-cream border-y border-detail/70">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-8 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
      {(content.trust_items?.length ? content.trust_items : TRUST_ITEMS).map((item, i) => {
        const Icon = ICONS[item.icon];
        return (
          <Reveal key={item.title} delay={i * 0.1}>
            <div className="flex items-center gap-4 sm:justify-center">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-detail text-brand">
                <Icon className="h-5 w-5" />
              </span>
              <span className="font-heading font-medium text-ink text-base">
                {item.title}
              </span>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
